import { Component, NgModule } from '@angular/core';
import { OnInit,Input,Output,EventEmitter } from '@angular/core';
import { OnChanges, SimpleChanges } from '@angular/core';
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {TreeNode,TreeModule} from 'primeng/primeng';
import {MamAdminService} from "../../service/mam_service.component";



@Component({
  selector: 'ex-attribute-group-tree',
  templateUrl: './attribute-group-tree.component.html',
  styleUrls: ['./attribute-group-tree.component.css']
})
export class AttributeGroupTreeComponent implements OnInit,OnChanges{

  private group_list:TreeNode[];
  private selected_group:TreeNode;


  @Input() company:any;
  @Input() treeReset
  @Output() onSelect:EventEmitter<any> = new EventEmitter();

  constructor(private service:MamAdminService, private logger : Logger) {

  }

  ngOnInit() {
      this.selected_group = null;
  }
  ngOnChanges(changes: SimpleChanges){
      this.logger.debug("treeReset",this.treeReset);

    if(changes['company'] != undefined){
      var new_company = changes['company'].currentValue;
      if(new_company != undefined){
        this.loadAttributeGroupByCompany(new_company);
      }
    }
    this.selected_group = null;
  }

  private loadAttributeGroupByCompany(company:any):void{
    this.logger.debug("--company changed : ", company);
    var url_path = "/mgr/system/attribute/group/" + company.id;
    this.service.get(url_path,null,null).subscribe(
        value => {
            this.logger.debug("loadUserGroup : ", value);
            this.group_list = value;

        },error=>{this.logger.error("-- error : " + error); }
        ,()=>{
          this.logger.info("-- complate : ");
        }
    )
  }
  private onSelectGroup(event):void{
    this.logger.debug("selected groupd :: ",event);
    if(this.onSelect != null){
      this.onSelect.emit(event.node);
    }
  }
}

@NgModule({
    imports:[TreeModule],
    declarations:[AttributeGroupTreeComponent],
    exports:[AttributeGroupTreeComponent],
    providers:[]
})
export class AttributeGroupTreeModule{
}




// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/attribute-group-tree/attribute-group-tree.component.ts